import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Player } from 'src/models/player.model';
import { PlayerService } from './players.service';
import { faPhone, faEnvelope, faCommentAlt, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { MyScores } from 'src/models/myscores.model';
import { UserService } from 'src/services/user.service';
import { map } from 'rxjs/operators';
import { ProfileService } from '../profile/profile.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BulkEmailComponent } from './bulkemail.component';



@Component({
  selector: 'players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.scss']
})
export class PlayersComponent implements AfterViewInit, OnDestroy {
  public busy: boolean;
  public loggedInPlayer: Player;
  public players: Player[][] = [];
  public alreadyPlayedIds: string[] = [];
  public faPhone = faPhone;
  public faEnvelope = faEnvelope;
  public faText = faCommentDots;
  private evtUser: Subscription;
  private loggedInUserId: string;
  public showAvatar: boolean = true;
  @Input("waitingRoom") waitingRoom: boolean = false;

  constructor(private authorizeService: AuthorizeService,
    private dialog: MatDialog,
    private userSvc: UserService, private playerSvc: PlayerService,
    private profileSvc: ProfileService, private http: HttpClient) {
    this.busy = true;
    this.showAvatar = !!(localStorage.getItem('showAvatar') == 'true');
  }

  public showAvatarChanged(evt: any) {
    this.showAvatar = evt;
    localStorage.setItem('showAvatar', this.showAvatar.toString());
  }

  ngAfterViewInit(): void {
    const p1 = this.playerSvc.playerList();
    const p2 = this.playerSvc.getScores();
    const p3 = this.userSvc.getUser();
    forkJoin([p1, p2, p3]).subscribe(
      ([resp1, resp2, resp3]) => {
        // a list of everyone you played so far, so we can gray them out
        const s = new MyScores(resp2);
        this.alreadyPlayedIds = s.results[0].scores.map(s => s.opponentId);
        // add yourself as gray too
        this.loggedInPlayer = new Player(resp3);
        if (this.loggedInPlayer.isDoubles) {
          this.alreadyPlayedIds.push(this.loggedInPlayer.doublesId);
        }
        else {
          this.alreadyPlayedIds.push(this.loggedInPlayer.id);
        }
        // the list of all other players
        this.players.length = 0;
        // this is a list of player lists  PlayerList[] in case there are doubles teams
        const listOfListsOfPlayers = resp1;
        listOfListsOfPlayers.forEach(pList => {
          let x: Player[] = [];
          pList.forEach(player => {
            var p = new Player(player);
            //if (this.loggedInPlayer.ladderType == 'Tiebreak') {
            this.profileSvc.getAvatar(p.id).subscribe(
              (resp) => p.avatar = resp.base64img,
              (err) => { } // no avatar found
            );
            //}
            x.push(p);
          });
          this.players.push(x);
        });
        // sort the N/R to the top, and then by rank letter
        //this.players.sort((p1: Player[], p2: Player[]) => p1[0].rank > p2[0].rank ? 1 : -1);
        this.players.sort((p1: Player[], p2: Player[]) => {
          if (p1[0].rank == null) return -1;
          if (p2[0].rank == null) return 1;
          if (p1[0].rank > p2[0].rank) return 1;
          return -1;
        });


        // get notified if the user is looking at this page and updates their profile message
        this.evtUser = this.userSvc.EventUserUpdate.subscribe((player) => this.reloadUser());

        this.busy = false;
      },
      (err) => { }
    );
  }

  // when this user updates their message, we get notified to reload the list so the UI updates
  private reloadUser() {
    this.playerSvc.playerList().subscribe(
      (resp) => {
        // the list of all other players
        this.players.length = 0;
        const listOfListsOfPlayers = resp; // this is a LIST of player LISTS  PlayerList[]
        listOfListsOfPlayers.forEach(pList => {
          let x: Player[] = [];
          pList.forEach(player => {
            x.push(new Player(player))
          });
          this.players.push(x);
        });
        this.players = this.players.sort((p1: Player[], p2: Player[]) => { return p1[0].rank > p2[0].rank ? 1 : -1; })
      }
    )
  }

  public busyEmail: boolean = false;
  bulkemailopponents(evt:any) {
    this.busyEmail = true;
    evt.preventDefault();
    const dialogConfig = new MatDialogConfig();
    var dlg = this.dialog.open(BulkEmailComponent, dialogConfig);
    //const user = this.players.find(f => f.id == id);
    dlg.afterClosed().subscribe(
      (data:{days:string, times: string, preferredContact:string}) => {
        if( data == null ) {
          this.busyEmail = false;
          return;
        }

      this.http.post('/api/bulkemailopponents', data).subscribe(
        (resp) => {
          this.busyEmail = false;
        },
        (err) => {
          alert(err);
          this.busyEmail = false;
        }
      );
      console.log(data);
  }
);
  }

  ngOnDestroy() {
    if (this.evtUser) {
      this.evtUser.unsubscribe();
      this.evtUser = null;
    }
  }

}
